import { AuthLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'

import AljanahIntegrationUpdateContainer from './AljanahIntegrationUpdateContainer'
import AljanahIntegrationCreateContainer from './AljanahIntegrationCreateContainer'

export default () => {
  return [
    {
      layout: AuthLayout,
      path: ROUTES.ALJANAH_INTEGRATION_CREATE_PATH,
      component: AljanahIntegrationCreateContainer
    },
    {
      layout: AuthLayout,
      path: ROUTES.ALJANAH_INTEGRATION_UPDATE_PATH,
      component: AljanahIntegrationUpdateContainer
    }
  ]
}
